// frontend/src/components/homepage/artefacts/MobileMock.js
//
// Tile 07's artefact: a dark phone with two skeleton lines, two KPI blocks and
// four bars that breathe (`hl-grow`, alternate). Pure CSS motion.
//
// The `<i>` / `<b>` elements are the prototype's own: bare boxes, no text.

import React, { memo } from "react";

function MobileMock() {
  return (
    <div className="hl-ft-ph" aria-hidden="true">
      <i />
      <i />
      <div className="hl-ft-k">
        <b />
        <b />
      </div>
      <div className="hl-ft-bars">
        <i />
        <i />
        <i />
        <i />
      </div>
    </div>
  );
}

export default memo(MobileMock);
